import React from 'react';
import { appConfig as config } from 'roc-package-web-app-react/app/shared/universal-config';
import { themer } from '@spp/theme-provider';

import FbComments from '@vg/fb-comments';

// eslint-disable-next-line react/prop-types
const Comments = ({ location }) => {
    const { query: { url } = {} } = location;

    if (!url) {
        return null;
    }

    const decodedUrl = decodeURIComponent(url);

    const {
        comments: {
            facebook: {
                appId,
                buttonText,
                commentsAlwaysOpen,
                commentsClosedHeading,
                commentsClosedText,
                commentsCloseHour,
                commentsOpenHour,
                cookie,
                lang,
                minutesLeftWhenWarningDisplayed,
                numPosts,
                version,
                widgetWidth,
                xfbml,
            } = {},
        } = {},
    } = config;

    return (
        <FbComments
            appId={appId}
            buttonText={buttonText}
            cookie={cookie}
            commentsAlwaysOpen={commentsAlwaysOpen}
            commentsClosedHeading={commentsClosedHeading}
            commentsClosedText={commentsClosedText}
            commentsOpenHour={commentsOpenHour}
            commentsCloseHour={commentsCloseHour}
            lang={lang}
            minutesLeftWhenWarningDisplayed={minutesLeftWhenWarningDisplayed}
            numPosts={numPosts}
            url={decodedUrl}
            version={version}
            widgetWidth={widgetWidth}
            xfbml={xfbml}
        />
    );
};

export default themer('@vg/fb-comments')(Comments);



/** WEBPACK FOOTER **
 ** ./src/screens/embed/fb-comments/index.js
 **/